import { Box, Button, Grid } from '@mui/material';
import { IDraftCardFooter } from './types';
import DeleteIcon from 'assets/icons/buttons/draft-delete.svg';
import EditIcon from 'assets/icons/buttons/draft-edit.svg';
import { styles } from './styles';

export const DraftCardFooter = ({
  postfix,
  isDraftActive,
  completePrefix,
  onComplete,
  onDelete,
}: IDraftCardFooter) => {
  const buttons = [
    {
      id: 1,
      sx: styles.completeButton,
      title: `${completePrefix} ${postfix}`,
      leftIcon: <EditIcon />,
      onClick: onComplete,
    },
    {
      id: 2,
      sx: styles.deleteButton,
      title: `Delete ${postfix}`,
      leftIcon: <DeleteIcon />,
      hidden: isDraftActive,
      onClick: onDelete,
    },
  ];

  return (
    <Grid sx={styles.container}>
      {buttons.map(
        ({ id, sx, title, leftIcon, hidden, onClick }) =>
          !hidden && (
            <Button key={id} fullWidth sx={sx} onClick={onClick}>
              <Grid sx={styles.buttonContent}>
                {leftIcon}
                <Box>{title}</Box>
              </Grid>
            </Button>
          )
      )}
    </Grid>
  );
};
